import styled from 'styled-components';

export const PeopleDrawerAccountHolderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PeopleDrawerAccountHolderTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 10px;
`;

export const PeopleDrawerAccountHolderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const PeopleDrawerAccountHolderTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const PeopleDrawerAccountHolderClientsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;
